module.exports = __webpack_public_path__ + "img/ring_g_e_0_1@3x.043c8d3a.png";